import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BannerNotification } from '@platform/types/notification.model';

@Component({
    selector: 'emma-page',
    templateUrl: './emma-page.component.html',
    standalone: false
})
export class EMMAPageComponent {
  @Input() pageTitle = '';
  @Input() pageDescription = '';
  @Input() icon = '';
  @Input() showHelpVideoBtn = true;
  @Input() titleModalVideoEmbed = '';
  @Input() youtubeVideoEmbed = '';

  @Input() notifications: Array<BannerNotification> = [];
  @Input() announcements: Array<BannerNotification> = [];

  @Input() backButton: boolean | string = false;
  @Input() backButtonLabel = $localize`Volver a la pantalla principal`;

  constructor(private readonly router: Router) {}

  goBack() {
    if (this.backButton) {
      if ('string' === typeof this.backButton) {
        this.router.navigateByUrl(this.backButton);
      } else {
        window.history.back();
      }
    }
  }
}
